import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { CFRD_FACILITIES } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/cfrd/facilities/")({
  component: () => <DeptContentList cfg={CFRD_FACILITIES} />,
});
